// extracted by mini-css-extract-plugin
export var contained = "ArticleListing-module--contained--13ed2";
export var container = "ArticleListing-module--container--69cd7";
export var title = "ArticleListing-module--title--c7021";
export var wrapper = "ArticleListing-module--wrapper--e099b";